module.exports = __webpack_public_path__ + "static/media/five.7ca6162f.svg";